import { useEffect, useState } from 'react'
import axios from 'axios'
import { Pagination } from 'antd'
import AuditAlumniEventRegistration from './ribbon'
import AlumniEventRegistrationDetail from './detail'

export default function AlumniEventRegistration() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [currentPage, setCurrentPage] = useState(1)
  const [propsData, setPropsData] = useState({})
  const [alumniEventRegistrationData, setAlumniEventRegistrationData] = useState({})
  const [isDetailVisible, setIsDetailVisible] = useState(false)

  const initialConditions = {
      status: 0,
      event_oid: ''
    }
    const [filterValue, setFilterValue] = useState(initialConditions)

  const getAlumniEventRegistrationData = () => {
    axios.post('/p/alumni/event/registration/list/get', { 
      merchant_oid: merchantOid,
      status: filterValue.status,
      event_oid: filterValue.event_oid,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setAlumniEventRegistrationData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'registrations': response.data.registrations
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAlumniEventRegistrationData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, currentPage, filterValue])

  const getColor = (key) => {
    if (key === 2) return 'green'
    if (key === 3) return 'red'
    return 'black'
  }

  const previewDetail = (oid) => {
    setIsDetailVisible(true)
    setPropsData({ oid: oid})
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">报名管理</div>
          <AuditAlumniEventRegistration 
            filterValue={filterValue} 
            setFilterValue={setFilterValue}
          />
        </div>

        <div className='public-main-style2'>
          <table className='public-main-style2-item'>
            <thead>
              <tr className='public-main-style2-thead'>
                <th style={{textAlign: 'left', paddingLeft: '20px'}}>报名人</th>
                <th>报名活动</th>
                <th>审核状态</th>
                <th>报名时间</th>
              </tr>
            </thead>

            <tbody>
              {alumniEventRegistrationData.registrations && (alumniEventRegistrationData.registrations.length > 0 ? (alumniEventRegistrationData.registrations.map((item) => (
                <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { previewDetail(item.oid) }}>
                  {item.alumni_photo_url ?  
                    <td style={{textAlign: 'left', padding: '5px 0 5px 20px', display: 'flex', alignItems: 'center'}}>
                      <img style={{height: '50px', marginRight: '10px'}} src={item.alumni_photo_url} alt="" />
                      {item.alumni_name}
                    </td> : <td style={{textAlign: 'left', paddingLeft: '20px'}}>{item.alumni_name}</td>
                  }
                  <td>{item.event_title}</td>
                  <td style={{ color: getColor(item.status.key) }}>{item.status.value}</td>
                  <td>{item.create_time}</td>
                </tr>
              ))) : (
                <tr className='public-main-style2-tbodyEmpty'>
                  <td colSpan="4"><span>暂无数据</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className='pagination'>
          <Pagination 
            current={currentPage}
            total={alumniEventRegistrationData.total}
            pageSize={20}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total) => `共${total}条`}
            showSizeChanger={false}
            hideOnSinglePage={true}
            showQuickJumper={true}
          />
        </div>

        {isDetailVisible && <AlumniEventRegistrationDetail
          data={propsData}
          isOpen={isDetailVisible}
          getAlumniEventRegistrationData={getAlumniEventRegistrationData}
          isCancel={() => { setIsDetailVisible(false) }}
        />}
      </div>
    </div>
  )
}
